const src = import.meta.ROLLUP_FILE_URL_OestAvA2SyLT4CG6L76dAw;
export default {
  src,
  srcSet: src + " " + 1332 + "w",
  width: 1332,
  height: 890,
};